
document.addEventListener('DOMContentLoaded', () => {
let filterClearbtn = document.querySelector('label[for="Filter--clear"]');
filterClearbtn.addEventListener('click', (e) => {
e.preventDefault();
// clear the search params
window.location.search = '';
});

// check the clear filter button if there are no search params
if (window.location.search == '') {
    document.querySelector('label[for="Filter--clear"] input').setAttribute('checked', 'checked');
    document.querySelector('label[for="Filter--clear"] input').dispatchEvent(new Event('change'));
}
});